<template>
  <div>
    <div class="pc-on">
      <header class="pc-header">
        <div class="pc-header__inner">
          <h1 class="pc-header__logo"><router-link :to="{ name: 'rankingHome'}">abceed</router-link></h1>
          <div class="pc-header__search">
            <input type="text" placeholder="検索" class="oval-form" v-model="searchWord" @keyup="searchBooksFromLetter">
          </div>
          <nav class="pc-header__nav">
            <ul class="pc-nav">
              <li class="pc-nav__list">
                <router-link :to="{ name: 'rankingHome'}" class="pc-nav__link">ランキング</router-link>
              </li>
              <li class="pc-nav__list pc-drop-nav" @mouseleave="isGenreShown = false">
                <a href="#" class="pc-nav__link" :class="{routerLinkExactActive: isCategoryActive}" @mouseenter="isGenreShown = true">ジャンル</a>
                <ul class="pc-drop-nav__main" v-if="isGenreShown && isCategoryShown">
                  <li v-for="category in categories">
                    <router-link :to="'/categories/' + category.id_category">{{category.name_category}}</router-link>
                  </li>
                </ul>
              </li>
              <!-- <li class="pc-nav__list">
                <router-link :to="{ name: 'premiumHome'}" class="pc-nav__link" :class="{routerLinkExactActive: isPremiumActive}">
                  プレミアム
                </router-link>
              </li> -->
              <!-- <li class="pc-nav__list"><router-link :to="{ name: 'UnlimitedPlus' }" class="pc-nav__link pc-nav__link--long">アンリミテッドプラス</router-link></li>-->
              <li class="pc-nav__list pc-drop-nav" @mouseleave="isAccountShown = false" v-if="isLogin">
                <a href="#" class="pc-nav__link" :class="{routerLinkExactActive: isAccountActive}"  @mouseenter="isAccountShown = true">アカウント</a>
                <ul class="pc-drop-nav__main" v-if="isAccountShown">
                  <li><router-link :to="{ name: 'settingHome'}">設定</router-link></li>
                  <li><router-link :to="{ name: 'historyHome'}">購入履歴</router-link></li>
                  <li><router-link :to="{ name: 'settingPaymentWay'}">お支払い方法</router-link></li>
                  <li>
                    <a href="https://www.globeejapan.com/faq.html" target="_blank">
                      FAQ
                    </a>
                  </li>
                  <li><a href="javascript:void(0);" @click="logout">ログアウト</a></li>
                </ul>
              </li>
              <li class="pc-nav__list" v-else><router-link :to="{ name: 'loginHome'}" class="pc-nav__link">ログイン</router-link></li>
            </ul>
          </nav>
        </div>
      </header>
      <div class="pc-search-area pc-on" v-if="isPcSearchMode">
        <div>
          <a v-for="book in searchFilterddBooks" :href="'/books/' + book.id_book"  class="pc-search-area__item">{{book.name_book}}</a>
        </div>
      </div>
    </div>
    <div class="sp-on">
      <header class="header" v-if="headerType === 'default'">
        <h1 class="header__ttl">{{headerTitle}}</h1>
        <a href="javascript:void(0);" class="header__nav" @click="navOpen">
          <span class="nav-opener"></span>
        </a>
        <a href="javascript:void(0);" class="header__search" @click="showSearch"><i class="fas fa-search"></i></a>
      </header>
      <header class="header" v-if="headerType === 'review'">
        <h1 class="header__ttl">{{headerTitle}}</h1>
        <a href="javascript:void(0);" @click="historyBack" class="header__back"><i class="fas fa-chevron-left"></i></a>
        <a href="javascript:void(0);" class="header__nav double-left-nav" @click="navOpen">
          <span class="nav-opener"></span>
        </a>
        <router-link :to="'/books/' + $route.params.id + '/reviews/add'" class="header__search">投稿</router-link>
      </header>
      <header class="header" v-if="headerType === 'back'">
        <h1 class="header__ttl">{{headerTitle}}</h1>
        <router-link :to="{ name: backLink }" class="header__back"><i class="fas fa-chevron-left"></i></router-link>
        <a href="javascript:void(0);" class="header__search" @click="showSearch"><i class="fas fa-search"></i></a>
      </header>
      <header class="header" v-if="headerType === 'historyBack'">
        <h1 class="header__ttl">{{headerTitle}}</h1>
        <a href="javascript:void(0);" @click="historyBack" class="header__back"><i class="fas fa-chevron-left"></i></a>
        <a href="javascript:void(0);" class="header__nav double-left-nav" @click="navOpen">
          <span class="nav-opener"></span>
        </a>
        <a href="javascript:void(0);" class="header__search" @click="showSearch"><i class="fas fa-search"></i></a>
      </header>
      <header class="header" v-if="headerType === 'historyBackNotSearch'">
        <h1 class="header__ttl">{{headerTitle}}</h1>
        <a href="javascript:void(0);" @click="historyBack" class="header__back"><i class="fas fa-chevron-left"></i></a>
        <a href="javascript:void(0);" class="header__nav double-left-nav" @click="navOpen">
          <span class="nav-opener"></span>
        </a>
      </header>
      <header class="header" v-if="headerType === 'setting'">
        <h1 class="header__ttl">{{headerTitle}}</h1>
        <a href="javascript:void(0);" @click="historyBack" class="header__back"><i class="fas fa-chevron-left"></i></a>
        <a href="javascript:void(0);" class="header__nav double-left-nav" @click="navOpen">
          <span class="nav-opener"></span>
        </a>
        <router-link :to="{ name: 'settingAccount' }" class="header__search" @click="showSearch">編集</router-link>
      </header>
      <header class="header header--unsubscribe" v-if="headerType === 'unsubscribe'">
        <h1 class="unsubscribe-ttl"><a href="/">abceed</a></h1>
      </header>
      <app-side :isNavOpen="isNavOpen"></app-side>
    </div>
  </div>
</template>

<script>
import Side from './Side.vue';
import $ from 'jquery';

export default {
  props: ["headerTitle", "headerType"],
  components: {
    appSide: Side
  },
  data() {
    return {
      isGenreShown: false,
      isAccountShown: false,
      searchWord: '',
      isCategoryActive: false,
      isAccountActive: false,
      isPremiumActive: false,
      isCategoryShown: false,
      searchdBooks: [],
      searchFilterddBooks: [],
      scrollY: 0,
    }
  },
  beforeCreate() {
    this.$http.get('webstore/book/titles')
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      })
      .then(data => {
        this.searchBooks = data.book_list;
      })
      .catch(() => {
      });

    let token = "";
    if (this.$route.query.token) {
      token = this.$route.query.token;
    }
    this.$store.dispatch('getCategories', {token:token})
      .then(data => {
        this.isCategoryShown = true;
        //ログイン成功の場合はログイン処理を行う
        if (data.has_logined) {
          if (data.login_info) {
            this.$store.dispatch("setLogin", data.login_info);
          }
        }
      })
      .catch(() => {
        this.isCategoryShown = false;
      });
  },
  mounted() {
    this.activeLinkCheck();
  },
  updated() {
    this.activeLinkCheck();
    this.setAppFixed();
  },
  computed: {
    isNavOpen() {
      return this.$store.getters.isNavOpen;
    },
    backLink() {
      return this.$store.getters.backLink;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    categories() {
      return this.$store.getters.categories;
    },
    isPcSearchMode() {
      return this.$store.getters.isPcSearchMode;
    },
  },
  methods: {
    setAppFixed() {
      if ($(window).width() <= 768) {
        if (this.isNavOpen) {
          this.scrollY = $(window).scrollTop();
          $('#app').css("top", `-${this.scrollY}px`);
          $('#app').addClass('fixed');
        } else {
          $('html, body').animate({scrollTop: this.scrollY}, 3);
          $('#app').removeClass('fixed');
        }
      }
    },
    activeLinkCheck() {
      if (this.$route.name === 'categoryDetail') {
        this.isCategoryActive = true;
        this.isAccountActive = false;
        this.isPremiumActive = false;
      } else if (this.$route.name === 'historyHome') {
        this.isCategoryActive = false;
        this.isAccountActive = true;
        this.isPremiumActive = false;
      } else if (this.$route.name === 'premiumHome') {
        this.isCategoryActive = false;
        this.isAccountActive = false;
        this.isPremiumActive = true;
      } else {
        this.isCategoryActive = false;
        this.isAccountActive = false;
        this.isPremiumActive = false;
      }
    },
    navOpen() {
      this.$store.dispatch("navToggle", true);
    },
    showSearch() {
      this.$store.dispatch("toggleSearch", true);
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        location.href = this.$route.path;
      });
    },
    searchBooksFromLetter() {
      if (this.searchWord) {
        this.searchFilterddBooks = this.searchBooks.filter(obj => {
          return obj.name_book.toLowerCase().indexOf(this.searchWord.toLowerCase()) != -1;
        });
        if (this.searchFilterddBooks.length > 0) {
          this.$store.dispatch("changePcSearchMode", true);
        } else {
          this.$store.dispatch("changePcSearchMode", false);
        }
      } else {
        this.searchFilterddBooks = [];
        this.$store.dispatch("changePcSearchMode", false);
      }
    },
    historyBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped lang="scss">
  .header__search {
    font-size: 16px;
    font-size: 1.6rem;
  }
  .double-left-nav {
    transform: translate(40px, -51%);
  }
  .header {
    &--unsubscribe {
      justify-content: flex-start;
      padding: 0 20px;
    }
  }
  .unsubscribe-ttl {
    a {
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      color: #FF5B60;
      font-size: 18px;
      font-size: 1.8rem;
    }
  }

  .pc-nav__link--long {
    width: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue